import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials envia o cookie httpOnly mcmv_token automaticamente.
export const api = axios.create({ baseURL: API, withCredentials: true });

export const ASSETS = {
  brasao: "https://customer-assets.emergentagent.com/job_portal-grajau-mcmv/artifacts/hu2la68x_Bras%C3%A3o%20da%20Prefeitura.png",
  banner: "https://customer-assets.emergentagent.com/job_06bd8eb9-671b-4381-8bba-20c84b3323d4/artifacts/l3zcts43_Banner%20instituciona.jpg",
  logoMcmv: "https://customer-assets.emergentagent.com/job_06bd8eb9-671b-4381-8bba-20c84b3323d4/artifacts/vqadxszt_Logo%20do%20Programa%20Minha%20Casa%20Minha%20Vida.png",
};

export const RENDA_FAIXA1_LIMITE = 3200;

export const formatCPF = (v) => {
  const d = (v || "").replace(/\D/g, "").slice(0, 11);
  return d.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2");
};

export const formatCEP = (v) => (v || "").replace(/\D/g, "").slice(0, 8).replace(/(\d{5})(\d)/, "$1-$2");

export const formatPhone = (v) => {
  const d = (v || "").replace(/\D/g, "").slice(0, 11);
  if (d.length <= 10) return d.replace(/(\d{2})(\d{4})(\d)/, "($1) $2-$3");
  return d.replace(/(\d{2})(\d{5})(\d)/, "($1) $2-$3");
};

export const onlyDigits = (v) => (v || "").replace(/\D/g, "");

export const formatMoney = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

// Helper para baixar arquivos protegidos via fetch com credentials.
export async function downloadFile(path, suggestedName) {
  const r = await fetch(`${API}${path}`, { credentials: "include" });
  if (!r.ok) throw new Error("Falha no download");
  const blob = await r.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  if (suggestedName) a.download = suggestedName;
  else a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
